import * as React from 'react';

import Navbar from "../../Layouts/Navbar";
import { BiSearchAlt, BiSolidCarBattery} from "react-icons/bi";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import Header from "../../Layouts/Header";

import {BsChevronCompactLeft} from "react-icons/bs";
import {HiOutlineQrcode} from "react-icons/hi";
import {LiaApple} from "react-icons/lia";
import {GiElectric} from "react-icons/gi";
import {TbStatusChange} from "react-icons/tb";
import {LuCalendarClock} from "react-icons/lu";


export default function SearchProduct() {

    const [code, setCode] = React.useState('');
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [data, setData] = React.useState(null);

    const onButtonClick = () => {
        if(code.length < 13) {
            toast.error('کد باتری را کامل وارد کنید')
            return false
        }
        setIsLoaded(false);
        API.searchProduct(code)
            .then((response) => {
                setData(response.data)
                setIsLoaded(true);

            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    React.useEffect(() => {

        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)

    }, []);

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header hasBack={true} title='NGKH'  />




            <section className="section mt-4 rtl">
                <div className="row mx-2 py-5 mb-5">
                    <div className="col-12 pt-3">

                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <BiSearchAlt className='mx-2' />
                                    جستجو و مشاهده اطلاعات باتری
                                </h5>
                                <div className='mt-4 ltr'>
                                    <div className="input-group flex-nowrap">
                                        <button className="input-group-text"
                                              data-toggle="modal" data-target="#exampleModal"


                                        >

                                        </button>
                                        <input type="number" className="form-control text-center text-small-1" placeholder="کد یکتای باتری" aria-label="کد یکتای باتری" aria-describedby="addon-wrapping"
                                        value={code}
                                               onChange={(val) => {
                                                   if(val.target.value.length > 14) return
                                                   setCode(val.target.value)
                                               }}
                                        />
                                    </div>
                                    <div className="row rtl mt-3 pt-2">
                                        <div className="col-2">

                                        </div>

                                        <div className="col-12">
                                            <button className='btn btn-warning w-100 text-small-2 text-white text-center ps-1'
                                            disabled={code.length !== 14}
                                                    onClick={onButtonClick}
                                            >
                                                <BiSolidCarBattery className='text-big-4 float-end'
                                                />

                                                مشاهده اطلاعات باتری
                                                <BsChevronCompactLeft className='text-big-4 float-start'
                                                />
                                            </button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 mt-3">

                        <div className="card">
                            {
                                data &&
                                <div className="card-body py-4">

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            کد یکتای باتری:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.code}
                                        </div>
                                    </div>


                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <LiaApple />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            برند:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.brand}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <GiElectric />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            آمپراژ:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.properties[0]?.amperage}
                                            <span className='me-2 text-small-2 text-muted'>
                                                آمپر
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <TbStatusChange />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            وضعیت:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2"
                                             style={{color: data?.status?.color}}
                                        >
                                            {data?.status?.title}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <LuCalendarClock />
                                        </div>
                                        <div className="col-md-5 col-10 text-small-2 pt-1">
                                            تاریخ پایان گارانتی:
                                        </div>
                                        <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                            {data?.warranty_end_date}
                                        </div>
                                    </div>


                                </div>
                            }
                        </div>

                    </div>


                </div>
            </section>


            <Navbar />
        </React.Fragment>
    );
};
